import React, { useMemo, useCallback } from 'react';
import { CollectionManagementHeader } from 'components/common/general/CollectionManagementPanel';
import { observer } from 'mobx-react-lite';
import { AddEmployeesDropdown } from 'components/common/rfq/add-employess/AddEmployeesDropdown';
import { useInitiateAddEmployeesPageStore } from 'store/pages/rfq/initiate-add-employees/pageStore';
import { EmployeesStatusFilterDropdown } from 'components/common/add-employees/EmployeesStatusFilterDropdown';
import useEnrollmentQuoteUrlParams from 'global/hooks/useEnrollmentQuoteUrlParams';
import { debounce } from 'global/utils/debounce';
import { AddOnFilterDropdown } from 'components/rfq/initiate-rfq/initiate-add-employees/AddOnMethodFilterDropdown';
import { useRootStore } from 'store/rootStore';
import { HeaderSectionStyled } from './styles';
import { TABLE_MANAGEMENT_PANEL_TEST_IDS } from '../constants';

export const TableManagementPanel: React.FC = observer(() => {
  const { paginationDelegate, employees } = useInitiateAddEmployeesPageStore();
  const { periodId, cartId, groupId } = useEnrollmentQuoteUrlParams();
  const { domainStoreV2 } = useRootStore();

  const debouncedSearch = useMemo(
    () =>
      debounce((searchValue: string) => {
        paginationDelegate.setFilterValue('employeeName', searchValue);
      }, 300),
    [paginationDelegate],
  );

  const handleSearch = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      debouncedSearch(e.target.value);
    },
    [debouncedSearch],
  );

  return (
    <CollectionManagementHeader
      data-test-id={TABLE_MANAGEMENT_PANEL_TEST_IDS.COLLECTION_MANAGEMENT_HEADER}
      elementsTitle="employees"
      page={paginationDelegate.page}
      currentElements={employees.length}
      elementsPerPage={12}
      totalElements={paginationDelegate.totalElements}
      onSearch={handleSearch}
      searchInputPlaceholder="Employee Name"
      headerSection={
        <HeaderSectionStyled>
          <AddEmployeesDropdown
            availableAddEmployeesActions={domainStoreV2.availableAddEmployeesActions}
            data-test-id={TABLE_MANAGEMENT_PANEL_TEST_IDS.ADD_EMPLOYEES_DROPDOWN}
            censusRedirectLink={`/census-initiate-add-employees-upload/${groupId}?periodId=${periodId}&cartId=${cartId}`}
          />
          <AddOnFilterDropdown
            data-test-id={TABLE_MANAGEMENT_PANEL_TEST_IDS.ADD_ON_FILTER_DROPDOWN}
            paginationDelegate={paginationDelegate}
          />
          <EmployeesStatusFilterDropdown
            data-test-id={TABLE_MANAGEMENT_PANEL_TEST_IDS.EMPLOYEES_STATUS_FILTER_DROPDOWN}
            paginationDelegate={paginationDelegate}
          />
        </HeaderSectionStyled>
      }
    />
  );
});
